/*
 * Copyright (c) 2025 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const PlaySvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29.1316 12.8776C31.2895 13.9876 31.2895 16.7624 29.1316 17.8724L4.85526 30.3593C2.69737 31.4693 -1.08917e-07 30.0819 0 27.862L1.22531e-06 2.88804C1.33423e-06 0.668137 2.69737 -0.719302 4.85526 0.39065L29.1316 12.8776Z" fill="currentColor"/>
  </svg>
);

export const PlayIcon = props => <Icon component={PlaySvg} {...props} />;
